var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { question: true, disabled: _vm.restricted === true } },
    [
      _c(
        "a",
        {
          class: "question-title",
          on: {
            click: function($event) {
              _vm.showQuestionModal(
                "Question",
                _vm.question,
                _vm.formattedTitle
              )
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.formattedTitle) + "\n\t")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "last-asked" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.formattedLastAsked) + "\n\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "frequency" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.frequency) + "\n\t")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3303388f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3303388f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question/Question.vue
// module id = null
// module chunks = 